import { ArrowForward } from '@mui/icons-material';
import { Box, Button, Paper, PaperProps, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useBeforeUnload } from 'react-use';
import { PageHeader } from '../../../../components/PageHeader';
import { useXmlDataStore } from '../../../../hooks/useXmlDataStore';
import { useXmlProcessController } from '../../../../hooks/useXmlProcessController';
import { PageContent, PageLayout } from '../../../../layout';
import { XmlSummaryCards } from './modules/XmlSummaryCards';

const TRANS_NS = 'xml-upload';

export const XMLSummaryPage = () => {
  const { t } = useTranslation(TRANS_NS);
  const { xmlDataModel } = useXmlDataStore();
  const { updateXmlProcess } = useXmlProcessController();

  // ask user to confirm before leaving page since the data are not saved
  useBeforeUnload(true, 'Opuštěním stránky přijdete o data v paměti a proces nahrání xml budete muset začít znovu.');

  return (
    <PageLayout>
      <PageHeader title={t('title')} subtitle={t('summary.title')} backRouteTo={'/upload'} />
      <PageContent
        sx={{
          flexDirection: 'column',
          justifyContent: 'flex-start',
          gap: { md: 8, xs: 2 },
        }}
      >
        <SummaryCard
          invoicesFound={xmlDataModel.noInvoices}
          customers={xmlDataModel.noCustomers}
          customersLeftToFill={xmlDataModel.noCustomersForUpsertWithoutContactInfo}
          sx={{ width: '100%' }}
        />
        <XmlSummaryCards xmlData={xmlDataModel} />
        <Box display={'flex'} width={'100%'} justifyContent={'flex-end'}>
          <Button size={'large'} variant={'contained'} onClick={updateXmlProcess} endIcon={<ArrowForward />}>
            {t('continue')}
          </Button>
        </Box>
      </PageContent>
    </PageLayout>
  );
};

type SummaryCardProps = {
  invoicesFound: number;
  customers: number;
  customersLeftToFill: number;
} & PaperProps;
const SummaryCard = ({ invoicesFound, customers, customersLeftToFill, sx, ...rest }: SummaryCardProps) => {
  const { t } = useTranslation('xml-upload');
  return (
    <Paper sx={{ px: 4, py: 3, borderColor: 'primary.main', ...sx }} {...rest}>
      <Stack direction={'row'} justifyContent={'space-between'} flexWrap={'wrap'} alignItems={'center'} gap={4}>
        <Stack>
          <Typography variant={'h3'}>{invoicesFound}</Typography>
          <Typography variant={'h6'} color={'gray'}>
            {t('summary.invoicesFound', { count: invoicesFound })}
          </Typography>
        </Stack>
        <Typography variant={'subtitle2'}>{t('summary.for')}</Typography>
        <Stack>
          <Typography variant={'h3'}>{customers}</Typography>
          <Typography variant={'h6'} color={'gray'}>
            {t('summary.forCustomer', { count: customers })}
          </Typography>
        </Stack>
        <Typography variant={'subtitle2'}>{t('summary.ofWhich')}</Typography>
        <Stack>
          <Typography variant={'h3'}>{customersLeftToFill}</Typography>
          <Typography variant={'h6'} color={'gray'}>
            {t('summary.customersLeftToFillInfo', {
              count: customersLeftToFill,
            })}
          </Typography>
        </Stack>
      </Stack>
    </Paper>
  );
};
